import UserDataManager from "../../../../manager/user_manager";
import ComponentBase from "../../../public/component/component_base";
import { IUserData } from "../../../public/model_data";
import Utility from "../../../../utility/utility";
import PublicPlayerAvatar from "../../../public/component/public_player_avatar";


const {ccclass, property} = cc._decorator;

@ccclass
export default class ChatFriendItem extends ComponentBase {

    @property(PublicPlayerAvatar)
    avatar: PublicPlayerAvatar = null

    @property(cc.Node)
    offlineMask : cc.Node = null

    private _index : number;
    public get index() : number {
        return this._index;
    }    

    private _data : any;
    public get data() : any {
        return this._data;
    }

    public get friendId() : number{
        return this._data.friendId;
    }


    updateInfo(index:number,data : any){

        this._index = index;
        this._data = data;

        //let content = JSON.parse(data.content);

        this.offlineMask.active = !data.online;

        // UserDataManager.getAvatarSprite(data.headImg,(spriteFrame)=>{
        //     this.icon.spriteFrame = spriteFrame;
        // });

        this.avatar.show(true, this.friendId)
       
    }

    

}
